import { Component, OnInit } from '@angular/core';
import { ThemePalette, ProgressSpinnerMode, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { EmployeeOrderEditComponent } from '../employee-order-edit/employee-order-edit.component';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-employee-order-for-current-month',
  templateUrl: './employee-order-for-current-month.component.html',
  styleUrls: ['./employee-order-for-current-month.component.scss']
})
export class EmployeeOrderForCurrentMonthComponent implements OnInit {

  title:any;
  employee_list:any;
  search_term: any;
  filtered_employee_list: any;
  final_employee_list = [];
  today_date: any;
  month: any;
  year: any;
  this_order_is_placed = null;
  employee_order_list = [];
  is_disabled = false;
  is_loaded = true;
  loading_spinner = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  element_already_present:any = null;
  element_have_null_field:any = null;
  next_month: any;
  next_year: any;
  monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];

  selected_employee_code: any;

  constructor(private http: HttpService, private router: Router, private dialog: MatDialog) { 
    this.loading_spinner = true;
    this.http.getEmployeeList().subscribe((data) => {
      this.employee_list = data;
      this.loading_spinner = false;
    });
    this.getCurrentDate();
  }

  async getCurrentDate() {
    this.today_date = await this.http.getCurrentDate();
    this.month = new Date(this.today_date).getMonth();
    this.year = new Date(this.today_date).getFullYear();
  }

  searchEmployeeCalled(search_term) {
    console.log(search_term);
    if (this.search_term == null || this.search_term === '') {
      this.loading_spinner = false;
      this.filtered_employee_list = [];
    } else {
      this.filtered_employee_list = this.employee_list.filter((element) => {
        return element.employee_name.toLowerCase().indexOf(search_term.toLowerCase()) > -1 || element.employee_code.toLowerCase().indexOf(search_term.toLowerCase()) > -1;
      });
    }
  }

  isSelected(){
    if (this.filtered_employee_list != null || this.filtered_employee_list != []){
      this.loading_spinner = false;
    }
  }

  openDialog(edit_field, index, employee_order): void {
    console.log('dialog open');
    const dialogRef = this.dialog.open(EmployeeOrderEditComponent, {
      height: '250px',
      width: '665px',
      data: {
        'input': edit_field,
        'employee_order': employee_order,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      const res = result;
      console.log(res);
      this.employee_order_list[index][edit_field] = res['value'];
      console.log(this.employee_order_list[index])
    });
  }

  removeItem(employee_order){
    if (confirm('இந்த ஆர்டரை கண்டிப்பாக நீக்க வேண்டுமா?')) {
      console.log(employee_order);
      this.http.deleteSelectedIcustomerSaleForCurrentMonth(employee_order).subscribe((data) => {
        console.log(data);
        this.employee_order_list = [];
      }, (error) => {
        console.error(error);
      });
    }
  }

  submitClicked(search_term){

    console.log("---------------------------------", search_term);
    this.employee_order_list = [];
    let data_dict = {
      'employee_code': search_term,
      'month': this.month + 1,
      'year': this.year
    }
    console.log(data_dict)
    this.http.placeNewEmployeeOrderForCurrentMonth(data_dict).subscribe((data) => {
      console.log(data);
      this.element_already_present =  this.employee_order_list.find(ob => ob.employee_code === data['data'][0].employee_code)
      console.log(this.element_already_present)
      if (this.element_already_present == null && this.employee_order_list.length == 0) {
        this.employee_order_list.push(data['data'][0]);
        this.element_already_present = null;
      }
      else {
        alert('One Order At a time...!')
        this.element_already_present = null;
      }
      this.search_term = null; 
    });
    console.log(this.employee_order_list);
  }

  orderClicked() {
    this.element_have_null_field =  this.employee_order_list.find(ob => ob.product === null)
    if(this.element_have_null_field != null){
      this.is_loaded = true;
      alert("Product field is not filled !!!");
    } else{
      if(confirm('Are you sure to order ?')){
        this.is_loaded = false;
        this.is_disabled = true;
        let data_dict = {
          'customer_type_id': this.employee_order_list[0]['customer_type'],
          'employee_order_list': this.employee_order_list
        }
        console.log('----------------------------------------------------------------------------------------')
        console.log(data_dict)
        this.http.placeEmployeeOrderForCurentMonth(data_dict).subscribe((data) => {
          if(data == true){
            this.is_loaded = true;
            alert("Order Successfuly Placed");
            this.employee_order_list = [];
            this.router.navigate(['/new/employee/order']);
          }
        }, (error) => {
          return "Some error occured";
        });
      }
    }
  }

  ngOnInit() {
  }

}
